module.exports = __webpack_public_path__ + "static/media/www.paappa.fi.3a44438b.jpg";